import React from 'react';
import { Card } from '../ui/Card';
import { BadgeIcon } from 'lucide-react';
export function MembershipTab() {
  return <div data-id="element-361">
      <Card title="Membership Status" data-id="element-362">
        <div className="flex items-center gap-3 mb-4" data-id="element-363">
          <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center" data-id="element-364">
            <BadgeIcon className="w-5 h-5 text-indigo-600" data-id="element-365" />
          </div>
          <div data-id="element-366">
            <h3 className="font-medium" data-id="element-367">Premium Membership</h3>
            <p className="text-sm text-gray-500" data-id="element-368">
              Active until January 15, 2024
            </p>
          </div>
        </div>
        <div className="mt-4 p-3 bg-gray-50 rounded-md" data-id="element-369">
          <h4 className="font-medium text-sm" data-id="element-370">Membership Benefits:</h4>
          <ul className="mt-2 text-sm text-gray-600 space-y-1" data-id="element-371">
            <li data-id="element-372">• Priority booking</li>
            <li data-id="element-373">• 10% discount on all classes</li>
            <li data-id="element-374">• Free monthly workshop</li>
          </ul>
        </div>
      </Card>
    </div>;
}